"use client";

import { Button } from "~/components/ui/button";
import { Download, User } from "lucide-react";
import { useUser } from "~/lib/user-context";

interface ProtectedDownloadLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "outline" | "ghost" | "destructive" | "secondary" | "link";
  size?: "default" | "sm" | "lg" | "icon";
}

export function ProtectedDownloadLink({ 
  href, 
  children, 
  className, 
  variant = "default", 
  size = "default" 
}: ProtectedDownloadLinkProps) {
  const { isFullyRegistered, loading } = useUser();

  // 如果用户已登录，显示正常的下载按钮
  if (isFullyRegistered) {
    const handleClick = (e: React.MouseEvent) => {
      e.preventDefault();
      window.open(href, '_blank');
    };

    return (
      <Button 
        className={className}
        variant={variant}
        size={size}
        onClick={handleClick}
        disabled={loading}
      >
        {children}
      </Button>
    );
  }

  // 如果用户未登录，显示登录提示
  return (
    <div className="text-center p-4 bg-slate-800/30 border border-slate-600 rounded-lg">
      {/* 提示文字区域 */}
      <div className="mb-4">
        <div className="flex items-center justify-center gap-2 text-slate-300 mb-2">
          <User className="h-4 w-4" />
          <span className="text-sm font-medium">Join our community!</span>
        </div>
        <div className="text-sm text-slate-400">
          <a 
            href="/auth/login" 
            className="text-cyan-300 hover:text-cyan-200 underline font-medium"
          >
            Log In
          </a>
          {" "}for an account to be able to download.
        </div>
      </div>
      
      {/* 禁用的下载按钮 */}
      <Button 
        disabled
        className={`${className} opacity-60 cursor-not-allowed w-full`}
        variant={variant}
        size={size}
      >
        {children}
      </Button>
    </div>
  );
} 